module.exports = "h4.seller_h {\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized-data/seller-info/seller-info.component.css
// module id = ./src/app/authorized-data/seller-info/seller-info.component.css
// module chunks = main